module.exports = __webpack_public_path__ + "img/thank_you.0bea8741.svg";